import HandymanIcon from '@mui/icons-material/Handyman';
import { COLORS } from '@/constants';
import { FC } from 'react';

export const MasterAdminIcon: FC<{ size?: number }> = ({ size = 20 }) => (
  <HandymanIcon sx={{ fontSize: size, color: COLORS['white'] }} />
);
